<template>
  <div :class="rootClass" :style="rootStyle" :id="rendering?.dataSource">
    <ContentGrid :desktop-default-grid="[2, 20]" :mobile-default-grid="[1, 14]">
      <JssRichText class="process-screen-title" :field="fields?.title" tag="h2" />
      <JssRichText class="process-screen-subtitle" :field="fields?.subtitle" />
      <div class="process-screen-content">
        <div class="process-screen-stepImage">
          <AdaptiveImage
            :field="fields?.stepImage"
            :isBackground="false"
            :lazy-load="false"
            :enableScrollDetection="false"
            :show="true"
          />
        </div>
      </div>
      <div
        class="process-screen-card"
        :style="{ '--process-card-columns': fields?.cardList?.length || 1 }"
        v-if="fields?.cardList?.length > 0"
      >
        <div class="process-screen-card-item" v-for="item in fields?.cardList" :key="item?.id">
          <div class="process-screen-card-item-header">
            <JssRichText
              class="process-screen-card-item-header-title"
              :field="item?.fields?.title"
            />
            <JssRichText class="process-screen-card-item-header-desc" :field="item?.fields?.desc" />
          </div>
          <JssRichText class="process-screen-card-item-tag" :field="item?.fields?.tag" />
        </div>
      </div>
      <div class="process-screen-tag">
        <JssRichText class="process-screen-tag-desc" :field="fields?.footerText" />
      </div>
    </ContentGrid>
  </div>
</template>

<script>
import { computed } from 'vue';
import utils from '@/utils';

export default {
  name: 'ProcessScreen',
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
    rendering: {
      type: Object,
    },
  },
  setup(props) {
    const rootClass = computed(() => utils.overall.baseComClass(props.fields, 'process-screen'));

    const rootStyle = computed(() => {
      const result = utils.overall.baseComStyle(props.fields);
      return result;
    });

    return {
      rootClass,
      rootStyle,
    };
  },
};
</script>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/functions';
@import '../../styles/mixins';

.process-screen {
  position: relative;
  width: 100%;
  padding: 40px 0;

  &-title {
    text-align: center;
  }

  &-subtitle {
    text-align: center;
    margin-top: 8px;
    font-size: 16px;
  }

  &-content {
    width: 100%;
    overflow: auto;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  &-stepImage {
    width: 1335px;
    margin-top: 24px;
  }

  &-card {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 16px;
    width: 100%;

    &-item {
      flex: 1;
      display: flex;
      flex-direction: column;
      border: 1px solid #ececec;
      border-radius: 16px;
      padding: 20px;

      &-header {
        flex: 1;
        background-color: #f6faf9;
        border-radius: 16px;
        padding: 16px;

        &-title {
          font-size: 18px;
          font-weight: 700;
          line-height: 20px;
          color: $grey-black;
        }

        &-desc {
          font-size: 14px;
          line-height: 1.2;
          color: $grey-black;
          margin-top: 12px;
        }
      }

      &-tag {
        font-size: 18px;
        font-weight: 700;
        line-height: 1.2;
        color: $grey-black;
        margin-top: 12px;
      }
    }
  }

  &-tag {
    background-color: #f6faf9;
    padding: 19px 16px;
    margin-top: 24px;
    border-radius: 16px;
    text-align: center;
    font-size: 14px;
    color: $grey-black;
    font-weight: 700;
    width: 100%;
  }

  @include tablet-landscape {
    padding: 60px 0;

    &-stepImage {
      width: 100%;
      margin-top: 32px;
    }

    &-card {
      display: grid;
      grid-template-columns: repeat(var(--process-card-columns, 1), 1fr);
      grid-template-rows: auto auto;
      row-gap: 0;
      column-gap: 16px;

      &-item {
        display: grid;
        grid-template-rows: subgrid;
        grid-row: span 2;

        &-header {
          display: flex;
          flex-direction: column;
        }

        &-header-desc {
          margin-top: auto;
        }
      }
    }
  }
}
</style>
